import { number, string } from "prop-types";

import styled from "styled-components";

import { useOtherNetworks } from "CrossFeatureComponents/MemberToolbar/API/queryHooks";
import LinkListRow from "NavBar/components/LinkListRow";
import { menuTypographyProps } from "NavBar/components/NavLink";

import FnrDivider from "UI/FnrDivider";
import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrScrollNFade from "UI/FnrScrollNFade";
import FnrTypography from "UI/FnrTypography";
import { colorsByFunction, marketingColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";

const Network = ({ photoURL, name, domain, shortname }) => {
  return (
    <LinkListRow
      to={`https://${domain}`}
      external
      data-cy={`NavBar_${shortname}`}
      borderRadius={8}
      omitNumericIndicator
    >
      <NetworkWrapper>
        <FnrNetworkPhoto noBorder size="xs" shape="circle" src={photoURL} />
        <FnrTypography key={domain} {...menuTypographyProps}>
          {name}
        </FnrTypography>
      </NetworkWrapper>
    </LinkListRow>
  );
};

Network.propTypes = {
  photoURL: string,
  name: string,
  domain: string,
  shortname: string,
};

const NetworkWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0 4px;
`;

const OtherNetworks = ({ settingsHeight }) => {
  const otherNetworks = useOtherNetworks();

  return (
    otherNetworks.length > 0 && (
      <>
        <FnrScrollNFade
          fullWidth
          maxHeight={`calc(80vh - ${settingsHeight}px)`}
          data-cy="UserButton_OtherNetworkWrapper"
          scrollbar={{
            color: marketingColors.darkBlue,
            backgroundColor: "transparent",
          }}
        >
          <NetworksWrapper>
            {otherNetworks.map((networkData) => (
              <Network key={networkData.domain} {...networkData} />
            ))}
          </NetworksWrapper>
        </FnrScrollNFade>
        <SFnrDivider
          color={addOpacity(colorsByFunction.textLight, 0.4)}
          marginX={8}
        />
      </>
    )
  );
};

OtherNetworks.propTypes = { settingsHeight: number };

const NetworksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const SFnrDivider = styled(FnrDivider)`
  padding-top: 1px;
  margin-bottom: 1px;
`;

export default OtherNetworks;
